export default "__VITE_ASSET__Cbb5AIhB__"